import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Leaf, Recycle, Factory, Package } from "lucide-react";

const EcoSection = () => {
  const { t } = useLanguage();

  const commitments = [
    { icon: Leaf, title: t("eco_materials"), desc: t("eco_materials_desc"), color: "from-green-500 to-emerald-500" },
    { icon: Recycle, title: t("eco_recycling"), desc: t("eco_recycling_desc"), color: "from-blue-500 to-cyan-500" },
    { icon: Factory, title: t("eco_production"), desc: t("eco_production_desc"), color: "from-purple-500 to-pink-500" },
    { icon: Package, title: t("eco_packaging"), desc: t("eco_packaging_desc"), color: "from-orange-500 to-yellow-500" },
  ];

  return (
    <section className="calli-section relative" data-testid="eco-section">
      <div className="absolute inset-0 animated-gradient"></div>
      <div className="glow-orb w-[400px] h-[400px] bg-green-500/20 bottom-0 left-1/4"></div>
      
      <div className="calli-container relative z-10">
        <div className="text-center mb-12 space-y-4">
          <span className="calli-badge">🌱 {t("eco_badge")}</span>
          <h2 className="text-4xl md:text-5xl font-black">
            {t("eco_title")}
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {commitments.map((item, index) => (
            <div 
              key={index}
              className="calli-glass rounded-2xl p-6 text-center group hover:scale-105 transition-all duration-300"
              data-testid={`eco-card-${index}`}
            >
              <div className={`w-14 h-14 mx-auto mb-4 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform`}>
                <item.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-bold mb-2 text-white">{item.title}</h3>
              <p className="text-sm text-gray-400">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcoSection;
